// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0c7c7317","732":"9d15e998","977":"932daf24"}[chunkId] + ".chunk.js";
};